import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-section">
          <div className="footer-info">
            <div className="footer-brand">
              <i className="fab fa-github"></i>
              <span>GitHub AI</span>
            </div>
            <p className="footer-description">
              智能 GitHub 项目搜索与分析平台
            </p>
          </div>
        </div>

        <div className="footer-section">
          <div className="footer-links">
            <h6>快速链接</h6>
            <ul>
              <li key="trending"><a href="#trending">热门项目</a></li>
              <li key="search"><a href="#search">项目搜索</a></li>
              <li key="favorites"><a href="#favorites">我的收藏</a></li>
              <li key="pricing"><Link to="/pricing">定价 / Pricing</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-section">
          <div className="footer-links">
            <h6>法律条款</h6>
            <ul>
              <li>
                <Link to="/terms">用户协议 (Terms &amp; Conditions)</Link>
              </li>
              <li>
                <Link to="/legal/privacy">隐私政策</Link>
              </li>
              <li>
                <Link to="/legal/refund">退款政策</Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="footer-section">
          <div className="footer-contact">
            <h6>联系我们</h6>
            <div className="contact-info">
              <div className="contact-item">
                <i className="fab fa-weixin"></i>
                <span>微信客服</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <div className="copyright">
            <span>&copy; 2024 GitHub AI. All rights reserved.</span>
          </div>
          <div className="beian-info">
            <a
              href="https://beian.miit.gov.cn"
              target="_blank"
              rel="noopener noreferrer"
              className="beian-link"
            >
              <i className="fas fa-shield-alt"></i>
              皖ICP备2025094730号
            </a>
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34060002040050"
              target="_blank"
              rel="noopener noreferrer"
              className="beian-link"
            >
              <i className="fas fa-shield-alt"></i>
              皖公网安备34060002040050号
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

